export default __webpack_public_path__ + "static/media/approval_img.0fe23125.svg";